import { registerComponentIcon } from '../utils/registerComponentIcon';
import { TeamsColor as OriginalTeamsColor } from '@fluentui/react-brand-icons';

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function registerComponentIcon called at module scope is not allowed. This may cause unwanted side effects. */
export const TeamsColor: string = registerComponentIcon('TeamsColor', OriginalTeamsColor);
